module.exports = __webpack_public_path__ + "static/img/BU02-4.aa14b3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU02-4.jpg
// module id = jN4X
// module chunks = 1